.root {
  border: solid 4px var(--color);
  border-radius: 3rem;
  display: flex;
  height: 2rem;
  justify-content: center;
  padding: 0.2rem 0;
  width: 1.6rem;
}

.circle {
  animation: circle-animation 1s infinite;
  background-color: var(--color);
  border-radius: 10rem;
  height: 0.5rem;
  width: 0.5rem;
}

@keyframes circle-animation {
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(22px);
  }
}
